export default "__VITE_ASSET__ELTlwNhe__"